import { urlConfig } from '@config/url.config';
import AbstractAPI from './Abstract.api';
import { GeoZoneRecord } from '../ui/features/Geozones/model';

export type CreateGeozoneDTO = Omit<GeoZoneRecord, "id">;

export interface UpdateGeozoneDTO extends GeoZoneRecord {}

export class GeozonesAPI extends AbstractAPI {
    async getAll(token: string) {
        const pathname = 'geozones/getAll';
        const method = 'POST';
        const body = { token };
        
        try {
            const response = await this._request<{ data: GeoZoneRecord[] }>(pathname, method, body);
            return response.data;
        } catch (e) {
            throw new Error(e);
        }
    }

    async getOne(token: string, id: string) {
        const pathname = 'geozones/get';
        const method = 'POST';
        const body = { token, id };

        try {
            const response = await this._request<{ data: GeoZoneRecord }>(pathname, method, body);
            return response.data;
        } catch (e) {
            throw new Error(e);
        }
    }

    async create(token: string, data: CreateGeozoneDTO) {
        const pathname = 'geozones/create';
        const method = 'POST';
        const body = {
            token,
            ...data
        };
        
        try {
            return await this._request<{ id: string }>(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }

    async update(token: string, data: UpdateGeozoneDTO) {
        const pathname = 'geozones/update';
        const method = 'POST';
        const body = {
            token,
            ...data
        };
        
        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }

    async delete(token: string, id: string) {
        const pathname = 'geozones/delete';
        const method = 'POST';
        const body = { token, id };

        try {
            return await this._request(pathname, method, body);
        } catch (e) {
            throw new Error(e);
        }
    }
}

export const geozonesAPI = new GeozonesAPI(urlConfig);
